import React from "react";
import ProductAnalysisShadow from "./ProductAnalysisShadow";

// カテゴリー分析（RN-161）: プロトの「カテゴリ別」ビューを単独表示する。
export default function CategoryAnalysisPage() {
    return <ProductAnalysisShadow views={["cat"]} defaultView="cat" />;
}
